import React, { useEffect, useState } from "react";
import { IonCol, IonPage, IonButton, IonRow, IonContent } from "@ionic/react";
import "./Preferences.scss";
import { isMobile } from "../../../utils/common";
import {
  PAGE_TITLES,
  PREFERENCE_DATA,
  PREFERENCE_ERROR_MESSAGE
} from "../../../utils/constants";
import { ToastMessage } from "../../../utils/ToastMessage";
import { PREFERENCE_STATUS_UPDATE_FAIL } from "../../../utils/constants";
import PreferencesListComponent from "./PreferencesListComponent";
import { FormatText } from "../Support/FormatTextComponent/formatText";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { UpdatePreferences } from "../../../actions/App/action";
import { logEvent, setScreenName } from "../../../utils/Analytics";
import { useLocation } from "react-router-dom";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import {
  PreferenceViewValidation,
  NoneChecker,
  defaultDataUncheck,
  toggeler,
  defaultDataCheck,
  defaultDataCheckforMarTech,
  defaultDataUncheckforMarTech,
  NoneCheckerforMarTech
} from "./PreferencesUtil";
import i18n from "../../../../i18n";

const PreferencesComponent: React.FC<any> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location: any = useLocation();
  const [openSubheading, setOpenSubheading] = useState<string>("");
  const [userInteraction, setUserInteraction] = useState<boolean>(false);
  const [isNone, setIsNone] = useState<boolean>(false);
  const [isNoneMarTech, setIsNoneMarTech] = useState<boolean>(false);
  const [statusUpdatevalueCount, setStatusUpdatevalueCount] = useState<boolean>(
    false
  );
  const storeData = useSelector(
    (state: any) => state && state.global && state.global.userPreferences
  );
  const UserPreferencesDomain = useSelector(
    (state: any) => state && state.global && state.global.userPreferencesDomain
  );
  const [preferenceList, setPreferenceList] = useState<any>([]);
  const [
    userInteractedPreferenceList,
    setUserInteractedPreferenceList
  ] = useState<any>([]);
  useEffect(() => {
    setScreenName(SCREEN.MANAGE_USER_PREFERENCES);
    logEvent(EVENT.SV_VIEW_PREFERENCES, {
      screen: SCREEN.MANAGE_USER_PREFERENCES
    });
  }, []);
  useEffect(() => {
    if (storeData) {
      if (location.state && location.state.openCapacityType === true) {
        setOpenSubheading("Capacity Type");
      } else {
        setOpenSubheading("");
      }
    }
  }, []);
  useEffect(() => {
    if (preferenceList) setPreferenceList(preferenceList);
  }, [preferenceList]);
  useEffect(() => {
    if (storeData) {
      let temp: any = [];
      let updatedStoreData = storeData.map((item: any) => {
        if (
          item.key === "preferredcapacitytype" &&
          item.userPreferenceExists === "No"
        ) {
          return { ...item, value: null };
        }
        return item;
      });
      try {
        updatedStoreData.forEach((element: any) => {
          switch (element.key) {
            case "viewsettings":
              PreferenceViewValidation("VIEW_SETTING") && temp.push(element);
              break;
            case "preferredcontact":
              PreferenceViewValidation("LOAD_RECOMENDATION") &&
                temp.push(element);
              NoneChecker(storeData) && setIsNone(true);
              break;
            case "preferredtime":
              PreferenceViewValidation("LOAD_RECOMENDATION") &&
                temp.push(element);
              break;
            case "preferreddaysofweek":
              PreferenceViewValidation("LOAD_RECOMENDATION") &&
                temp.push(element);
              break;
            case "preferredcapacitytype":
              PreferenceViewValidation("CAPACITY_TYPE") && temp.push(element);
              break;
            case "preferredstatusupdates":
              PreferenceViewValidation("STATUS_UPDATE") && temp.push(element);
              break;
            case "preferredmarketingcommunications":
              PreferenceViewValidation("MARKETING_COMMUNICATIONS") && temp.push(element);
              NoneCheckerforMarTech(storeData) && setIsNoneMarTech(true);
              break;              
            default:
              break;
          }
        });
      } finally {
        setPreferenceList(temp);
      }
    }
  }, [storeData]);
  useEffect(() => {
    if (isNone) {
      let temp: any = [...preferenceList];
      try {
        temp = temp.map((element: any) => {
          if (
            element.key === "preferredcontact" ||
            element.key === "preferredtime" ||
            element.key === "preferreddaysofweek"
          ) {
            let modifiedData: any = { ...element };
            if (element.key === "preferredcontact") {
              let { none, ...rest } = modifiedData.value;
              const updated_rest = Object.keys(rest).reduce(
                (accumulator, key) => {
                  return { ...accumulator, [key]: "false" };
                },
                {}
              );
              modifiedData = {
                ...modifiedData,
                value: { none: "true", ...updated_rest }
              };
            } else {
              modifiedData = {
                ...modifiedData,
                value: Object.keys(modifiedData.value).reduce(
                  (accumulator, key) => {
                    return { ...accumulator, [key]: "false" };
                  },
                  {}
                )
              };
            }
            return modifiedData;
          } else {
            return element;
          }
        });
      } finally {
        setPreferenceList(temp);
      }
    }
  }, [isNone]);
  useEffect(() => {
    if (isNoneMarTech) {
      let temp: any = [...preferenceList];
      try {
        temp = temp.map((element: any) => {
          if (
            element.key === "preferredmarketingcommunications"
          ) {
            let modifiedData: any = { ...element };
            if (element.key === "preferredmarketingcommunications") {
              let { none, ...rest } = modifiedData.value;
              const updated_rest = Object.keys(rest).reduce(
                (accumulator, key) => {
                  return { ...accumulator, [key]: "false" };
                },
                {}
              );
              modifiedData = {
                ...modifiedData,
                value: { none: "true", ...updated_rest }
              };
            } else {
              modifiedData = {
                ...modifiedData,
                value: Object.keys(modifiedData.value).reduce(
                  (accumulator, key) => {
                    return { ...accumulator, [key]: "false" };
                  },
                  {}
                )
              };
            }
            return modifiedData;
          } else {
            return element;
          }
        });
      } finally {
        setPreferenceList(temp);
      }
    }
  }, [isNoneMarTech]);
  const handleAccordionChange = (heading: string) => {
    setOpenSubheading(heading === openSubheading ? "" : heading);
  };
  const handleChange = (event: any, API_KEY: any, OPTION_TYPE: string) => {
    let temp: any = [...preferenceList];
    let data: any = temp.filter((item: any) => item.key === API_KEY)[0];
    let isNoneAction: any = { action: false, type: "" };
    let isNoneActionforMarTech: any = { action: false, type: "" };
    if (
      data &&
      (API_KEY === "preferredcapacitytype"
        ? data.value || data.value === null
        : data.value)
    ) {
      switch (OPTION_TYPE) {
        case "radio":
          let updatedRadioData: any = { ...data };
          updatedRadioData = { ...updatedRadioData, value: event.detail.value };
          data = { ...updatedRadioData };
          break;
        case "checkbox":
          let updatedData: any = { ...data.value };
          if (API_KEY === "preferredcontact") {
            if (event.target.name === "none") {
              if (event.target.checked === true) {
                isNoneAction = { action: true, type: "noneChecked" };
              } else {
                isNoneAction = { action: true, type: "noneUnchecked" };
              }
            } else {
              if (isNone) {
                isNoneAction = { action: true, type: "other" };
                updatedData = {
                  ...updatedData,
                  [event.target.name]: toggeler(updatedData[event.target.name]),
                  none: "false"
                };
              } else {
                const trueCount = (list: any[]): number =>
                  list.reduce(
                    (acc: number, cr: string): number =>
                      cr === "true" ? acc + 1 : acc,
                    0 as number
                  );
                if (
                  event.target.checked === false &&
                  trueCount(Object.values(updatedData)) === 1
                ) {
                  setIsNone(true);
                  isNoneAction = { action: true, type: "noneChecked" };
                } else {
                  updatedData = {
                    ...updatedData,
                    [event.target.name]: toggeler(
                      updatedData[event.target.name]
                    ),
                    none: "false"
                  };
                }
              }
            }
          } else {
            if (API_KEY === "preferredmarketingcommunications") {
              if (event.target.name === "none") {
                if (event.target.checked === true) {
                  isNoneActionforMarTech = { action: true, type: "noneCheckedforMarTech" };
                } else {
                  isNoneActionforMarTech = { action: true, type: "noneUncheckedforMarTech" };
                }
              } else {
                if (isNoneMarTech) {
                  isNoneActionforMarTech = { action: true, type: "other" };
                  updatedData = {
                    ...updatedData,
                    [event.target.name]: toggeler(updatedData[event.target.name]),
                    none: "false"
                  };
                } else {
                  const trueCount = (list: any[]): number =>
                    list.reduce(
                      (acc: number, cr: string): number =>
                        cr === "true" ? acc + 1 : acc,
                      0 as number
                    );
                  if (
                    event.target.checked === false &&
                    trueCount(Object.values(updatedData)) === 1
                  ) {
                    setIsNoneMarTech(true);
                    isNoneActionforMarTech = { action: true, type: "noneCheckedforMarTech" };
                  } else {
                    updatedData = {
                      ...updatedData,
                      [event.target.name]: toggeler(
                        updatedData[event.target.name]
                      ),
                      none: "false"
                    };
                  }
                }
              }
            }
            if (API_KEY === "preferredstatusupdates") {
              const trueCount = (list: any[]): number => {
                return list.reduce(
                  (acc: number, cr: string): number =>
                    cr === "true" ? acc + 1 : acc,
                  0 as number
                );
              };
              if (
                trueCount(Object.values(updatedData)) === 1 &&
                event.target.checked === false
              ) {
                setStatusUpdatevalueCount(true);
                {
                  isMobile
                    ? ToastMessage.show(PREFERENCE_STATUS_UPDATE_FAIL)
                    : ToastMessage.showWeb(PREFERENCE_STATUS_UPDATE_FAIL);
                }
              } else {
                setStatusUpdatevalueCount(false);
              }

              updatedData = {
                ...updatedData,
                [event.target.name]: toggeler(updatedData[event.target.name])
              };
            }
            if (
              API_KEY === "preferreddaysofweek" ||
              API_KEY === "preferredtime"
            ) {
              updatedData = {
                ...updatedData,
                [event.target.name]: toggeler(updatedData[event.target.name])
              };
            }
          }
          data = { ...data, value: { ...updatedData } };
          break;
        default:
          break;
      }
      if (isNoneAction.action) {
        if (isNoneAction.type === "noneChecked") {
          setIsNone(true);
          setTimeout(() => payloadUpdateHandler(defaultDataCheck), 1000);
        } else if (isNoneAction.type === "noneUnchecked") {
          temp = temp.map((element: any) => {
            if (
              element.key === "preferredcontact" ||
              element.key === "preferredtime" ||
              element.key === "preferreddaysofweek"
            ) {
              return defaultDataUncheck.find(
                (elem: any) => elem.key === element.key
              );
            } else return element;
          });
          setIsNone(false);
          setPreferenceList(temp);
          payloadUpdateHandler(defaultDataUncheck);
          setOpenSubheading("");
          setTimeout(() => {
            setOpenSubheading("Load Recommendations");
          }, 1);
        } else {
          temp = temp.map((element: any) => {
            if (
              element.key === "preferredtime" ||
              element.key === "preferreddaysofweek"
            )
              return defaultDataUncheck.find(
                (elem: any) => elem.key === element.key
              );
            if (element.key === API_KEY) return data;
            return element;
          });
          const payloadUpdateHandlerData = temp.filter(
            (item: any) =>
              item.key === "preferredcontact" ||
              item.key === "preferredtime" ||
              item.key === "preferreddaysofweek"
          );
          setIsNone(false);
          setPreferenceList(temp);
          payloadUpdateHandler(payloadUpdateHandlerData);
        }
      } 
      else  if (isNoneActionforMarTech.action) {
        if (isNoneActionforMarTech.type === "noneCheckedforMarTech") {
          setIsNoneMarTech(true);
          setTimeout(() => payloadUpdateHandler(defaultDataCheckforMarTech), 1000);
        } else if (isNoneAction.type === "noneUncheckedforMarTech") {
          temp = temp.map((element: any) => {
            if (
              element.key === "preferredmarketingcommunications"
            ) {
              return defaultDataUncheckforMarTech.find(
                (elem: any) => elem.key === element.key
              );
            } else return element;
          });
          payloadUpdateHandler(defaultDataUncheckforMarTech);
          setPreferenceList(temp);
          setIsNoneMarTech(false);
        } else {
          temp = temp.map((element: any) => {
            if (
              element.key === "preferredtime" ||
              element.key === "preferreddaysofweek"
            )
              return defaultDataUncheck.find(
                (elem: any) => elem.key === element.key
              );
            if (element.key === API_KEY) return data;
            return element;
          });
          const payloadUpdateHandlerData = temp.filter(
            (item: any) =>
              item.key === "preferredmarketingcommunications"
          );
          setPreferenceList(temp);
          payloadUpdateHandler(payloadUpdateHandlerData);
          setIsNoneMarTech(false);
        }
      }else {
        payloadUpdateHandler([data]);
        temp = temp.map((element: any) => {
          if (element.key === API_KEY) return data;
          return element;
        });
        setPreferenceList(temp);
      }
    }
    if (!userInteraction) {
      setUserInteraction(true);
    }
  };
  const handleSubmit = () => {
    if (statusUpdatevalueCount) {
      isMobile
        ? ToastMessage.show(PREFERENCE_STATUS_UPDATE_FAIL)
        : ToastMessage.showWeb(PREFERENCE_STATUS_UPDATE_FAIL);
    } else {
      let temp: any = userInteractedPreferenceList
        .filter(
          (content: any) =>
            content.key !== "preferredcapacitytype" ||
            (content.key === "preferredcapacitytype" && content.value !== null)
        )
        .map((item: any) => {
          let value: any = null;
          if (typeof item.value === "string") value = item.value;
          else value = JSON.stringify(item.value);
          return { key: item.key, value: value };
        });
      let payload = {
        domain: UserPreferencesDomain || "carrier",
        updatePreferences: [...temp]
      };
      dispatch(UpdatePreferences(payload));
      setOpenSubheading("");
      setScreenName(SCREEN.MANAGE_USER_PREFERENCES);
      logEvent(EVENT.UE_PREFERENCES_SAVE, {
        screen: SCREEN.MANAGE_USER_PREFERENCES
      });
      setUserInteraction(false);
      setUserInteractedPreferenceList([]);
    }
  };
  const payloadUpdateHandler = (data: any = {}) => {
    let temp = [...userInteractedPreferenceList];
    const data_filter: any[] = data.map((item: any) => item.key);
    temp = temp.filter((elem: any) => !data_filter.includes(elem.key));
    temp = [...temp, ...data];
    setUserInteractedPreferenceList(temp);
  };
  return (
    <IonPage
      className={isMobile ? "mobile-page" : "desktop-page"}
      data-testid="preference-page"
    >
      {isMobile ? (
        ""
      ) : (
        <h1 className="heading-search" data-testid="page-heading">
          {" "}
          {PAGE_TITLES.PREFERENCES}
        </h1>
      )}
      {PREFERENCE_DATA.length <= 0 || preferenceList.length <= 0 ? (
        <>
          {isMobile && (
            <div className="preference-error-message">
              <img
                alt="logo"
                src="assets/icon/no-preference.svg"
                width="85px"
                height="89.74px"
                className="no-preference-icon"
              />
              <FormatText
                text={PREFERENCE_ERROR_MESSAGE}
                dataType={"richText"}
              />
            </div>
          )}
          <IonCol className={`${isMobile ? "ion-text-center" : ""}`}>
            No preference available
          </IonCol>
        </>
      ) : isMobile ? (
        <IonContent>
          {PREFERENCE_DATA.map((item: any, index: any) =>
            PreferenceViewValidation(item.ACCORD_ROLE_FILTER_KEY) ? (
              <PreferencesListComponent
                singleAccordion={item}
                preferenceList={preferenceList}
                key={index}
                handleAccordionChange={handleAccordionChange}
                handleChange={handleChange}
                openSubheading={openSubheading}
                isNone={isNone}
                isNoneMarTech={isNoneMarTech}
                cssClass="preference-list"
                statusUpdatevalueCount={statusUpdatevalueCount}
                userInteractedPreferenceList={userInteractedPreferenceList}
              />
            ) : (
              <React.Fragment key={index} />
            )
          )}
        </IonContent>
      ) : (
        <>
          {PREFERENCE_DATA.map((item: any, index: any) =>
            PreferenceViewValidation(item.ACCORD_ROLE_FILTER_KEY) ? (
              <PreferencesListComponent
                singleAccordion={item}
                preferenceList={preferenceList}
                key={index}
                handleAccordionChange={handleAccordionChange}
                handleChange={handleChange}
                openSubheading={openSubheading}
                isNone={isNone}
                isNoneMarTech={isNoneMarTech}
                statusUpdatevalueCount={statusUpdatevalueCount}
                cssClass="preference-list"
                userInteractedPreferenceList={userInteractedPreferenceList}
              />
            ) : (
              <React.Fragment key={index} />
            )
          )}
        </>
      )}
      {PREFERENCE_DATA.length > 0 && preferenceList.length > 0 && (
        <IonRow className={isMobile ? "" : "ion-text-right"}>
          <IonCol
            className={isMobile ? "preferences-button-mobile" : "btn-section"}
          >
            <IonButton
              data-testid="submit-button"
              onClick={() => userInteraction && handleSubmit()}
              className={`${
                isMobile
                  ? "primary-cta-btn-mobile W-100"
                  : "primary-cta-btn-web"
              } ${(!userInteraction || statusUpdatevalueCount) &&
                "button-disabled"} ion-no-margin`}
            >
              {i18n.t("Save")}
            </IonButton>
          </IonCol>
        </IonRow>
      )}
    </IonPage>
  );
};
export default PreferencesComponent;
